import { useTranslation } from "react-i18next";
import { Typography, type SxProps, type Theme } from "~/common/mui";

interface Props {
  quantity: number | null | undefined;
  className?: string;
  sx?: SxProps<Theme>;
}

export const PreferredPackaging = ({ quantity, className, sx }: Props) => {
  const { t } = useTranslation();

  if (!quantity) {
    return null;
  }

  return (
    <Typography color="textSecondary" className={className} sx={sx}>
      {t("addToCartPopup.prefPackQuantity", { count: quantity })}
    </Typography>
  );
};
